import store from "@/store/store";

export function getLocale() {
    return store.state.localisation.cultureCode;
}

export function getTimeZone() {
    return store.state.localisation.timeZone;
}